/**
 * Since only HTML Elements can be focused, we want to make sure we don't encounter a runtime error (and keep Typescript happy)
 * Side effects:
 * - Calls `node.focus()` if and only if `node instanceof HTMLElement`
 * */
export const focusIfHTMLElement = (node: Node | null | undefined): node is HTMLElement => {
  if (node instanceof HTMLElement) {
    node.focus();
    return true;
  }
  return false;
};

/**
 * Since only Elements can have attributes set, we want to make sure we don't encounter a runtime error (and keep Typescript happy)
 *
 * Side effects:
 * - Calls `node.setAttribute(qualifiedName, value)` if and only if `node instanceof Element`
 * */
export const setAttributeIfElement = (
  node: Node | null | undefined,
  qualifiedName: string,
  value: string
): node is Element => {
  if (node instanceof Element) {
    node.setAttribute(qualifiedName, value);
    return true;
  }
  return false;
};
